import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { createFrontendModule, TranslationBlueprint } from '@backstage/frontend-plugin-api';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';

const catalogMessages = createTranslationMessages({
  ref: catalogTranslationRef,
  full: true,
  messages: {
    'indexPage.title': 'Catálogo {{orgName}}',
    'indexPage.createButtonTitle': 'Criar',
    'indexPage.supportButtonContent': 'Todas as entidades do seu catálogo de software',
    
    'aboutCard.title': 'Sobre',
    'aboutCard.refreshButtonTitle': 'Agendar atualização',
    'aboutCard.editButtonTitle': 'Editar Metadados',
    'aboutCard.createSimilarButtonTitle': 'Criar algo similar',
    'aboutCard.refreshScheduledMessage': 'Atualização agendada',
    'aboutCard.launchTemplate': 'Iniciar template',
    'aboutCard.viewTechdocs': 'Documentação',
    'aboutCard.viewSource': 'Código Fonte',
    'aboutCard.descriptionField.label': 'Descrição',
    'aboutCard.descriptionField.value': 'Sem descrição',
    'aboutCard.ownerField.label': 'Proprietário',
    'aboutCard.ownerField.value': 'Sem Proprietário',
    'aboutCard.domainField.label': 'Domínio',
    'aboutCard.domainField.value': 'Sem Domínio',
    'aboutCard.systemField.label': 'Sistema',
    'aboutCard.systemField.value': 'Sem Sistema',
    'aboutCard.parentComponentField.value': 'Sem Componente Pai',
    'aboutCard.parentComponentField.label': 'Componente Pai',
    'aboutCard.typeField.label': 'Tipo',
    'aboutCard.lifecycleField.label': 'Ciclo de Vida',
    'aboutCard.tagsField.label': 'Tags',
    'aboutCard.tagsField.value': 'Sem Tags',
    'aboutCard.targetsField.label': 'Alvos',
    
    'searchResultItem.lifecycle': 'Ciclo de Vida',
    'searchResultItem.Owner': 'Proprietário',

    'catalogTable.warningPanelTitle': 'Não foi possível carregar entidades do catálogo.',
    'catalogTable.viewActionTitle': 'Ver',
    'catalogTable.editActionTitle': 'Editar',
    'catalogTable.starActionTitle': 'Favoritar',
    'catalogTable.unStarActionTitle': 'Desfavoritar',
    
    'dependencyOfComponentsCard.title': 'Dependência de componentes',
    'dependencyOfComponentsCard.emptyMessage': 'Nenhum componente depende deste componente',
    'dependsOnComponentsCard.title': 'Depende dos componentes',
    'dependsOnComponentsCard.emptyMessage': 'Nenhum componente é uma dependência deste componente',
    'dependsOnResourcesCard.title': 'Depende dos recursos',
    'dependsOnResourcesCard.emptyMessage': 'Nenhum recurso é uma dependência deste componente',

    'entityContextMenu.copiedMessage': 'Copiado',
    'entityContextMenu.moreButtonTitle': 'Mais',
    'entityContextMenu.inspectMenuTitle': 'Inspecionar entidade',
    'entityContextMenu.copyURLMenuTitle': 'Copiar URL da entidade',
    'entityContextMenu.unregisterMenuTitle': 'Descadastrar entidade',
    'entityLabelsCard.title': 'Rótulos',
    'entityLabelsCard.emptyDescription': 'Nenhum rótulo definido para esta entidade. Você pode adicionar rótulos ao YAML da sua entidade como destacado no exemplo abaixo:',
    'entityLabelsCard.readMoreButtonTitle': 'Ler mais',
    'entityLabels.warningPanelTitle': 'Entidade não encontrada',
    'entityLabels.ownerLabel': 'Proprietário',
    'entityLabels.lifecycleLabel': 'Ciclo de Vida',
    'entityLinksCard.title': 'Links',
    'entityLinksCard.emptyDescription': 'Nenhum link definido para esta entidade. Você pode adicionar links ao YAML da sua entidade como destacado no exemplo abaixo:',
    'entityLinksCard.readMoreButtonTitle': 'Ler mais',
    'entityNotFound.title': 'Entidade não foi encontrada',
    'entityNotFound.description': 'Quer ajudar a construir isto? Confira a página Getting Started da documentação',
    'entityNotFound.docButtonTitle': 'DOCUMENTAÇÃO',

    'deleteEntity.dialogTitle': 'Tem certeza de que deseja excluir esta entidade?',
    'deleteEntity.deleteButtonTitle': 'Excluir',
    'deleteEntity.cancelButtonTitle': 'Cancelar',
    'deleteEntity.description': 'Esta entidade não é referenciada por qualquer local e portanto não recebe atualizações. Clique aqui para excluí-la',
    
    'entityProcessingErrorsDescription': 'O erro abaixo se origina de',
    'entityRelationWarningDescription': 'Esta entidade é relacionada a outras entidades, que não foram encontradas no catálogo.\n Entidades não encontradas: ',
    
    'hasComponentsCard.title': 'Componentes',
    'hasComponentsCard.emptyMessage': 'Nenhum componente é parte deste sistema',
    'hasResourcesCard.title': 'Recursos',
    'hasResourcesCard.emptyMessage': 'Nenhum recurso é parte deste sistema',
    'hasSubcomponentsCard.title': 'Subcomponentes',
    'hasSubcomponentsCard.emptyMessage': 'Nenhum subcomponente é parte deste componente',
    'hasSubdomainsCard.title': 'Subdomínios',
    'hasSubdomainsCard.emptyMessage': 'Nenhum subdomínio é parte deste domínio',
    'hasSystemsCard.title': 'Sistemas',
    'hasSystemsCard.emptyMessage': 'Nenhum sistema é parte deste domínio',
    'relatedEntitiesCard.emptyHelpLinkTitle': 'Descubra como mudar isto',

    'systemDiagramCard.title': 'Diagrama de sistema',
    'systemDiagramCard.description': 'Utilize arrastar e aproximar para mover o diagrama',
    'systemDiagramCard.edgeLabels.dependsOn': 'depende de',
    'systemDiagramCard.edgeLabels.partOf': 'parte de',
    'systemDiagramCard.edgeLabels.provides': 'fornece'
  },
});

const catalogReactMessages = createTranslationMessages({
    ref: catalogReactTranslationRef,
    full: false,
    messages: {
        'catalogFilter.title': 'Filtros',
        'catalogFilter.buttonTitle': 'Filtros',
        'entityKindPicker.title': 'Categoria',
        'entityKindPicker.errorMessage': 'Falha ao carregar tipos de entidade',
        'entityLifecyclePicker.title': 'Ciclo de Vida',
        'entityNamespacePicker.title': 'Namespace',
        'entityOwnerPicker.title': 'Proprietário',
        'entityProcessingStatusPicker.title': 'Status de Processamento',
        'entityTagPicker.title': 'Tags',
        'entitySearchBar.placeholder': 'Buscar',
        'entityTypePicker.title': 'Tipo',
        'entityTypePicker.errorMessage': 'Falha ao carregar tipos de entidade',
        'entityTypePicker.optionAllTitle': 'Todos',
        'favoriteEntity.addToFavorites': 'Adicionar aos favoritos',
        'favoriteEntity.removeFromFavorites': 'Remover dos favoritos',
        'userListPicker.defaultOrgName': 'Empresa',
        'userListPicker.personalFilter.title': 'Pessoal',
        'userListPicker.personalFilter.ownedLabel': 'Possuídos',
        'userListPicker.personalFilter.starredLabel': 'Favoritos',
        'userListPicker.orgFilterAllLabel': 'Todos',
        
        'entityTableColumnTitle.name': 'Nome',
        'entityTableColumnTitle.system': 'Sistema',
        'entityTableColumnTitle.owner': 'Proprietário',
        'entityTableColumnTitle.type': 'Tipo',
        'entityTableColumnTitle.lifecycle': 'Ciclo de Vida',
        'entityTableColumnTitle.namespace': 'Namespace',
        'entityTableColumnTitle.description': 'Descrição',
        'entityTableColumnTitle.tags': 'Tags',
        'entityTableColumnTitle.targets': 'Alvos',
        'entityTableColumnTitle.title': 'Título',
        'entityTableColumnTitle.label': 'Rótulo',
        'entityTableColumnTitle.domain': 'Domínio',
    },
});

export const catalogReactTranslationModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    TranslationBlueprint.make({
      name: 'catalog-overrides',
      params: {
        resource: catalogMessages
      },
    }),
    TranslationBlueprint.make({
      name: 'catalog-react-overrides',
      params: {
        resource: catalogReactMessages
      },
    }),
  ]
})